import React from 'react';
import { adminApi } from '../api';

export default function AdminPush() {
  const [notifyForm, setNotifyForm] = React.useState({ title: '', body: '', tokens: '', data: '' });
  const [notifyResult, setNotifyResult] = React.useState('');
  const [sending, setSending] = React.useState(false);
  const [gaId, setGaId] = React.useState('');

  React.useEffect(() => {
    try {
      const id = (typeof window !== 'undefined' && window && window.GA_MEASUREMENT_ID) ? window.GA_MEASUREMENT_ID : '';
      setGaId(id || '');
    } catch {}
  }, []);

  const send = async () => {
    try {
      setSending(true);
      setNotifyResult('');
      let tokens = (notifyForm.tokens || '').split(',').map((s) => s.trim()).filter(Boolean);
      let data = {};
      try {
        data = notifyForm.data ? JSON.parse(notifyForm.data) : {};
      } catch {}
      const res = await adminApi.notify({ tokens, title: notifyForm.title, body: notifyForm.body, data });
      setNotifyResult(`Sent: ${res.sent}, Success: ${res.success || 0}, Failure: ${res.failure || 0}`);
    } catch (e) {
      setNotifyResult(e?.message || 'Failed to send');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="p-4">
      <div className="text-lg font-bold text-green-700 mb-1">Admin – Push Notifications</div>
      <div className="text-xs text-gray-600 mb-3">GA4 Measurement ID: {gaId || 'Not configured'}</div>
      <div className="bg-white border border-green-100 rounded-2xl p-3 shadow-sm">
        <div className="grid gap-2">
          <input className="border border-green-200 rounded px-3 py-2 text-sm" placeholder="Title" value={notifyForm.title} onChange={(e)=>setNotifyForm(s=>({...s, title: e.target.value}))} />
          <input className="border border-green-200 rounded px-3 py-2 text-sm" placeholder="Body" value={notifyForm.body} onChange={(e)=>setNotifyForm(s=>({...s, body: e.target.value}))} />
          <textarea className="border border-green-200 rounded px-3 py-2 text-sm" rows={3} placeholder="Tokens (comma-separated). Leave empty to send to all users" value={notifyForm.tokens} onChange={(e)=>setNotifyForm(s=>({...s, tokens: e.target.value}))} />
          <input className="border border-green-200 rounded px-3 py-2 text-sm" placeholder='Data JSON (optional), e.g. {"screen":"orders"}' value={notifyForm.data} onChange={(e)=>setNotifyForm(s=>({...s, data: e.target.value}))} />
          <div className="flex gap-2">
            <button disabled={sending} className="px-3 py-2 text-sm rounded bg-green-600 text-white disabled:opacity-60" onClick={send}>Send</button>
            <button className="px-3 py-2 text-sm rounded border border-green-200" onClick={()=>setNotifyForm({ title: '', body: '', tokens: '', data: '' })}>Clear</button>
          </div>
          {notifyResult && <div className="text-xs text-gray-700">{notifyResult}</div>}
        </div>
      </div>
    </div>
  );
}


